(function () {
  'use strict';

  if (customElements.get('bl-upsell')) return;

  // ----------------------------------------------------------------
  // Cart-add helper (canonical theme.js#L2660 pattern). Exposed as
  // window.BartiniCart.add so bl-variant-panel.js (and any future
  // Bartini code) can call it without duplicating the contract.
  // ----------------------------------------------------------------

  async function blCartAdd(variantId, quantity) {
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true, detail: { sections: sections }
    }));
    var fd = new FormData();
    fd.set('id', String(variantId));
    fd.set('quantity', String(quantity || 1));
    if (sections.length) fd.set('sections', sections.join(','));

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var addResp = await fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: fd
    });
    var addJson = await addResp.json();
    if (!addResp.ok) throw new Error((addJson && addJson.description) || 'Cart add failed');

    var cart = await (await fetch(root + 'cart.js')).json();
    if (addJson.sections) cart.sections = addJson.sections;

    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: 'variant:add', cart: cart, onSuccessDo: 'force_open_drawer' }
    }));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    return { item: addJson, cart: cart };
  }
  if (!window.BartiniCart) window.BartiniCart = {};
  window.BartiniCart.add = blCartAdd;

  // ----------------------------------------------------------------
  // <bl-upsell> — carousel + click delegation.
  //
  // Variant picking lives in <bl-variant-panel> (singleton in <body>).
  // This component just delegates to it via panel.open(handle, ...).
  // ----------------------------------------------------------------

  class BlUpsell extends HTMLElement {
    connectedCallback() {
      this._track = this.querySelector('.bl-upsell__track');
      this._prevArrow = this.querySelector('.bl-upsell__arrow--prev');
      this._nextArrow = this.querySelector('.bl-upsell__arrow--next');
      this._currentBtn = null;
      if (!this._track) return;

      this._bindArrows();
      this._bindAddButtons();
      this._updateArrowStates();
      this._scrollHandler = this._updateArrowStates.bind(this);
      this._track.addEventListener('scroll', this._scrollHandler, { passive: true });
    }

    disconnectedCallback() {
      if (this._track) this._track.removeEventListener('scroll', this._scrollHandler);
      if (this._onDelegatedClick) this.removeEventListener('click', this._onDelegatedClick);
    }

    // Carousel scroll.
    _bindArrows() {
      var self = this;
      if (this._prevArrow) this._prevArrow.addEventListener('click', function () { self._scrollByCard(-1); });
      if (this._nextArrow) this._nextArrow.addEventListener('click', function () { self._scrollByCard(1); });
    }
    _scrollByCard(direction) {
      var card = this._track.querySelector('.bl-upsell-card');
      if (!card) return;
      var w = card.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(this._track).gap) || 12;
      var maxScroll = this._track.scrollWidth - this._track.clientWidth;
      var sl = this._track.scrollLeft;
      var cardStep = w + gap;
      var tol = cardStep / 2;

      // Wrap-around: tolerância proporcional (meia-largura-de-card) absorve
      // sub-pixel rounding + offsets de padding-inline do track. Preserva
      // touch swipe nativo + scroll-snap.
      if (direction > 0 && sl >= maxScroll - tol) {
        this._track.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }
      if (direction < 0 && sl <= tol) {
        this._track.scrollTo({ left: maxScroll, behavior: 'smooth' });
        return;
      }

      this._track.scrollBy({ left: cardStep * direction, behavior: 'smooth' });
    }
    _updateArrowStates() {
      if (!this._prevArrow || !this._nextArrow) return;
      var max = this._track.scrollWidth - this._track.clientWidth;

      // Sem overflow (1 produto só): esconde ambas. Não faz sentido navegar.
      if (max <= 0) {
        this._prevArrow.hidden = true;
        this._nextArrow.hidden = true;
        return;
      }

      // Com overflow: ambas sempre visíveis e habilitadas (loop infinito via
      // wrap-around no _scrollByCard — setas nunca ficam disabled).
      this._prevArrow.hidden = false;
      this._nextArrow.hidden = false;
      this._prevArrow.disabled = false;
      this._nextArrow.disabled = false;
    }

    // ADD button dispatch via event delegation on the host.
    _bindAddButtons() {
      var self = this;
      this._onDelegatedClick = function (event) {
        var btn = event.target.closest('.bl-upsell-card__button');
        if (btn && self.contains(btn)) self._onAddClick(btn);
      };
      this.addEventListener('click', this._onDelegatedClick);
    }

    _onAddClick(btn) {
      var hasVariants = btn.getAttribute('data-has-variants') === 'true';
      var handle = btn.getAttribute('data-product-handle');
      if (!hasVariants || !handle) return this._directAdd(btn);

      var panel = document.querySelector('bl-variant-panel');
      if (!panel || typeof panel.open !== 'function') return this._directAdd(btn);

      // Toggle if same; switch if different.
      if (this._currentBtn === btn) {
        panel.close({ restoreFocus: true });
        return;
      }
      if (this._currentBtn) this._restoreBtn(this._currentBtn);

      this._markBtnSelecting(btn);
      this._currentBtn = btn;

      var self = this;
      panel.open(handle, {
        triggerBtn: btn,
        anchorTo: this, // <bl-upsell> covers carousel area
        onClose: function () {
          self._restoreBtn(btn);
          if (self._currentBtn === btn) self._currentBtn = null;
        }
      });
    }

    _markBtnSelecting(btn) {
      btn.setAttribute('data-state', 'selecting');
      btn.innerHTML = '▲ SELECTING';
    }

    _restoreBtn(btn) {
      btn.removeAttribute('data-state');
      btn.textContent = 'Add';
      btn.disabled = false;
    }

    async _directAdd(btn) {
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      btn.disabled = true; btn.textContent = 'Adding...';
      try {
        await blCartAdd(id, 1);
        btn.textContent = 'Added ✓';
        setTimeout(function () { btn.disabled = false; btn.textContent = 'Add'; }, 1500);
      } catch (err) {
        console.error('[bl-upsell] add failed:', err);
        btn.disabled = false; btn.textContent = 'Add';
      }
    }
  }

  customElements.define('bl-upsell', BlUpsell);
})();
